import {HttpClient, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable } from 'rxjs';
import { map, timeout } from 'rxjs/operators';
import { environment as env } from 'src/environments/environment';
import { PageRes } from '../models/datatable/page-res';
import { SearchQuotation } from '../models/quotation/search-quotation';
import { QuotationModel } from '../models/save-model/quotation-model';
import { TableValueModel } from '../models/save-model/table-value-model';
import { QuotationCopy, QuotationProductCopy } from '../models/quotation/quotation-copy';
import {QuotationInsurerInfo} from '../models/quotation/quotation-insurer-info';
import FileSaver from 'file-saver';
import { SearchModel } from '../models/search-model/search-model';
import { quotationUpdataPersonal } from '../models/quotation/quotation-updatePersonal';
import { QuotationEApp } from '../models/quotation/quotation-eApp';

@Injectable()
export class QuotationService {

  constructor(
    private http: HttpClient,
    private ngxLoaderService: NgxUiLoaderService,
  ) { }

  saveQuatation(data: Array<QuotationModel>): Observable<any> {
    const url = `${env.apiEndpoint}/quotation`;
    return this.http.post<any>(url, data).pipe(map((response) => {
      return response;
    }));
  }

  saveQuatationQQ(data: Array<QuotationModel>): Observable<any> {
    const url = `${env.apiEndpoint}/quickQuote/saveQuotations`;
    return this.http.post<any>(url, data).pipe(map((response) => {
      return response;
    }));
  }

  recalQuotationProducts(data: QuotationCopy):Observable<any>{
    const url = `${env.apiEndpoint}/quotation/updateQuotationProductDetail`;
    return this.http.post<any>(url, data).pipe(map((response) => {
        return response;
      }));
  }

  upDateQuatation(data: Array<QuotationModel>): Observable<any> {
    const url = `${env.apiEndpoint}/quickQuote/upDateQuotations`;
    return this.http.post<any>(url, data).pipe(map((response) => {
      return response;
    }));
  }

  getQuotationProduct(data: any): Observable<Array<any>> {
    const url = `${env.apiEndpoint}/quotation/qtProduct`;
    return this.http.post<any>(url, data).pipe(map((response) => {
      return response;
    }));
  }

  getQuotationProductDetail(data: any): Observable<any> {
    const url = `${env.apiEndpoint}/quotation/getQuotationProductDetail`;
    return this.http.post<any>(url, data).pipe(map((response) => {
      return response;
    }));
  }

  saveTableValue(data: Array<TableValueModel>): Observable<any> {
    const url = `${env.apiEndpoint}/quotation/saveTableValue`;
    return this.http.post<any>(url, data).pipe(map((response) => {
      return response;
    }));
  }

  generatePDF(quotationId, languageReport): Observable<Blob> {
    const language = '&languageReport=' + languageReport;
    const url = `${env.apiEndpoint}/quotation/genPDF/?quotationId=` + quotationId + language;
    const file = this.http.get<Blob>(
      url, {responseType: 'blob' as 'json'});
    return file;
  }

  generatePDFQQ(quotationId, languageReport): Observable<Blob> {
    const language = '&languageReport=' + languageReport;
    const url = `${env.apiEndpoint}/quickQuote/generatePDF/?quotationId=` + quotationId + language;
    const file = this.http.get<Blob>(
      url, {responseType: 'blob' as 'json'});
    return file;
  }

  sendMailgeneratePDFQQ(quotationId, languageReport): Observable<any> {
    const language = '&languageReport=' + languageReport;
    const url = `${env.apiEndpoint}/quickQuote/generatePDFSendMail/?quotationId=` + quotationId + language;
    return this.http.get<any>(url);
  }

  async downloadQuotation(quotationId, quotationNo, blob) {
    const fileName = 'quotation_' + quotationNo + '.pdf';
    const ios = this.getMobileOperatingSystem();
    // Firefox
    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      window.navigator.msSaveBlob(blob, fileName);
    } else if (ios) {
      const reader = new FileReader();
      const out = new Blob([blob], {type: 'application/pdf'});
      reader.onload = function(e) {
        if (typeof reader.result === 'string') {
          window.location.href = reader.result;
        }
      };
      // Safari
      const fileURL = (window['webkitURL']).createObjectURL(out);
      FileSaver.saveAs(fileURL, fileName);
      // reader.readAsDataURL(out);
    } else if (/Firefox/.test(navigator.userAgent)) {
      const out = new Blob([blob], {type: 'application/pdf'});
      const fileURL = (window.URL || window['webkitURL']).createObjectURL(out);
      FileSaver.saveAs(fileURL, fileName);
    } else {
      const out = new Blob([blob], {type: 'application/pdf;charset=UTF-8'});
      const fileURL = (window.URL || window['webkitURL']).createObjectURL(out);
      const downloadLink = document.createElement('a');
      downloadLink.href = fileURL;
      downloadLink.download = fileName;
      downloadLink.click();
    }
    this.ngxLoaderService.stop();
  }

  getMobileOperatingSystem() {
    return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  }

  sendEmail(data: number, emailTo, emailCc, personalId, languageReport): Observable<any> {
    const url = `${env.apiEndpoint}/mail/sendQuotation`;
    return this.http.post<any>(url, {
      quotationId: data, emailTo: emailTo, emailCc: emailCc,
      personalId: personalId, languageReport: languageReport
    }).pipe(timeout(60000), map((response) => {
      return response;
    }));
  }

  sendEmailQQ(data: number, emailTo, emailCc, personalId, languageReport): Observable<any> {
    const url = `${env.apiEndpoint}/quickQuote/sendQuotation`;
    return this.http.post<any>(url, {
      quotationId: data, emailTo: emailTo, emailCc: emailCc,
      personalId: personalId, languageReport: languageReport
    }).pipe(timeout(60000), map((response) => {
      return response;
    }));
  }

  getQuotationList(data: SearchQuotation): Observable<PageRes<any>> {
    const search = new SearchModel();
    search.agentCode = data.agentCode ? '' + data.agentCode : '';
    search.keyWord = data.personAssuredName ? data.personAssuredName : '';
    search.page = data.page;
    search.size = data.size;
    search.sort = data.sort;
    const url = `${env.apiEndpoint}/quotation/getQuotationList`;
    return this.http.post<any>(url, search).pipe(map((response) => {
      return {
        page: data.page,
        size: data.size,
        content: response.content,
        totalPages: response.totalPages,
        totalElement: response.totalElement
      };
    }));
  }

  getQuotationAssure(quotationId: number): Observable<QuotationCopy> {
    const url = `${env.apiEndpoint}/quotation/getQuotationAssure/${ quotationId }`;
    return this.http.get<any>(url);
  }

  deleteQuotation(data): Observable<any> {
    const url = `${env.apiEndpoint}/quotation/deleteQuotation`;
    return this.http.post<any>(url, data);
  }

  getBasicInsurePeriod(msProductId: number, age: number): Observable<any> {
    const url = `${env.apiEndpoint}/quotationProduct/getBasicInsurePeriod`;
    const productInsurePeriod = {
      msProductId: '' + msProductId,
      ageAssured: '' + age,
      memberType: '' + sessionStorage.getItem('familyType')
    };
    return this.http.post<any>(url, productInsurePeriod);
  }

  getRiderInsurePeriod(riderProductId: number, msProductId: number, ageAssured: number, agePayer: number, memberType: String): Observable<any> {
    const url = `${env.apiEndpoint}/quotationProduct/getRiderInsurePeriod`;
    const productInsurePeriod = {
      riderProductId: '' + riderProductId,
      msProductId: '' + msProductId,
      ageAssured: '' + ageAssured,
      agePayer: '' + agePayer,
      memberType: '' + memberType
    };
    return this.http.post<any>(url, productInsurePeriod);
  }

  getQuotationProductSelf(quotationId: string): Observable<Array<any>> {
    const url = `${env.apiEndpoint}/quotationProduct/getQuotationProductDetail`;
    return this.http.get<any>(url, {
      params: {
        quotationId: '' + quotationId
      }
    });
  }

  quotationSigned(agentSigned, leadSigned, quotationId): Observable<any> {
    const url = `${env.apiEndpoint}/quotation/quotationSigned`;
    return this.http.post<any>(url, {
      agentSigned: agentSigned, leadSigned: leadSigned,
      quotationId: quotationId
    }).pipe(map((response) => {
      return response;
    }));
  }

  getQuotationForCopy(quotationNo: string): Observable<QuotationCopy> {
    const url = `${env.apiEndpoint}/quotation/copyQuotation`;
    return this.http.post<any>(url, quotationNo);
  }

  getQuotationProductPaForCopy(quotationNo, productId, assuredId): Promise<QuotationProductCopy> {
    const url = `${env.apiEndpoint}/quotation/getQuotationProductPa`;
    return this.http.get<any>(url, {
      params: {
        quotationNo: quotationNo,
        productId: productId,
        assuredId: assuredId
      }
    }).toPromise();
  }

  getProspectDetail(quotationId, prospectId): Observable<{ prospect: QuotationInsurerInfo, payer: QuotationInsurerInfo }> {
    const url = `${env.apiEndpoint}/quotation/getQuotationPersonal`;
    return this.http.get<any>(url, {
      params: {
        quotationId: quotationId,
        prospectCustomerId: prospectId,
      }
    }).pipe(map(data => {
      const assure = data.qniTrPersonalBeanAssure;
      const payer = data.qniTrPersonalBeanPayer;
      const prospectMap: QuotationInsurerInfo = this.mapAssureToQuotationInsurerInfo(data, assure);
      const payerMap: QuotationInsurerInfo = this.mapAssureToQuotationInsurerInfo(data, payer);
      return { prospect: prospectMap, payer: payerMap };
    }));
  }

  updateQuotationPersonal(data: quotationUpdataPersonal[]): Observable<any> {
    const url = `${env.apiEndpoint}/quotation/updateQuotationPersonal`;
    return this.http.post<any>(url, data);
  }

  private mapAssureToQuotationInsurerInfo(data: any, assure: any): QuotationInsurerInfo {
    const name = '' + (assure.titleNameDesc ? assure.titleNameDesc : '')
      + (assure.firstName ? assure.firstName : '') + ' '
      + (assure.lastName ? assure.lastName : '');
    return {
      personalId: assure.personalId,
      leadId: assure.leadId,
      _leadId: data._leadId,
      _titleId: assure._titleId,
      name: name,
      prospectCustomerId: data.prospectCustomerId,
      productType: data.productType,
      firstName: assure.firstName,
      lastName: assure.lastName,
      tel: assure.tel,
      email: assure.email,
      birthDate: assure.birthDate,
      yearOfAge: assure.yearOfAge,
      salary: assure.salary,
      _msOccupationId: assure._msOccupationId,
      occupationDesc: assure.occupationDesc,
      citizenId: assure.citizenId,
      personalType: assure.personalType,
      personalCardExp: assure.personalCardExp,
      maritalStatusName: assure.maritalStatusName,
      nationalityName: assure.nationalityName,
      gender: assure.gender,
      provinceName: assure.provinceName,
      _provinceId: assure._provinceId,
      _maritalStatusId: assure._maritalStatusId,
      _nationalityId: assure._nationalityId,
      _relationId: assure._relationId,
      address: assure.qniTrAddressBeanList,
      sendingAddress: data.sendingAddress,
      yearDiff:  assure.yearDiff,
      monthDiff: assure.monthDiff,
      dateDiff: assure.dateDiff
    };
  }

  updateQuotationEapp(quotationEApp: QuotationEApp): any {
    const url = `${env.apiEndpoint}/quotation/saveQtEapp`;
    return this.http.post<any>(url, quotationEApp);
  }


}
